import { Injectable } from '@angular/core';

import { combineLatest, Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

import { SharedLanguageService } from '@language';
import { LocalesService } from '@mediahaven/shared';
import { User, UserService } from '@stylehaven/components';

@Injectable({ providedIn: 'root' })
export class LocaleResolverService {
    constructor(
        private readonly userService: UserService,
        private readonly translateService: SharedLanguageService,
        private readonly localeService: LocalesService
    ) {}

    resolve(): Observable<User> {
        return combineLatest([this.userService.getCurrentUser(), this.localeService.getLanguageLocalePairs()]).pipe(
            take(1),
            tap(([user, supportedLocales]) => {
                this.translateService.initSupportedLanguagesAndPairs(supportedLocales);
                this.translateService.changeLocale(user.Locale);
            }),
            map(([user]) => user)
        );
    }
}
